<template>
  <q-popup-proxy>
    <slot />
  </q-popup-proxy>
</template>
